import * as React from 'react';
//import PropTypes from 'prop-types';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { createTheme, Grid, Stack, Tooltip, ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorSnackbarNotification from '../../common/ErrorHandling/ErrorSnackbarAlert';
import { StyledTableCell, StyledTableCellTotal, StyledTableRow, styles } from '../../style/style';
import { add, setOrderRequestSearchField, setOrderRequestSearchType } from '../orderlist/orderListSlice';
import OrderSummaryDownloadTable from './OrderSummaryDownloadTable';
import { FormattedMessage, useIntl } from 'react-intl';
import log from '../../common/components/Logger'

const theme = createTheme({
    //sets color of text in dropdown/selectors 
        palette: {
          primary: {
            main: '#00439D',
          },
          secondary: {
            main: '#11cb5f',
          },
        },
      });

export default function OrderSummaryTable(props) {

    const intl = useIntl();
    const { chargeToBac, primaryFleetAccountNumber, partnerType, endUserFleetAccountNumber, chargeToBfc, shipToBac, modelYear } = props
    const [open, setOpen] = React.useState(-1);
    const dispatch = useDispatch();
    const [eventCodeList, setEventCodeList] = useState([]);
    const header = [];
    const total = [];
    const dataList = [];
    const dataGrp = [];
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [page, setPage] = React.useState(0);
    const dataListItem = useSelector((state) => state.searchFieldList.orderSummaryData.payload);
    const ApiList = useSelector((state) => state.apiList.apiList);
    const idToken = localStorage.getItem("idToken")
    const [statusMessage, setStatusMessage] = useState("")
    const [error, setError] = useState(false);
    const [errorType, setErrorType] = useState("")



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    dataListItem.filter(item => item.allocGrpCd.includes('Model')).map(filtered => {
        for (var key in filtered) {
            if (filtered.hasOwnProperty(key)) {
                if (filtered[key] !== null) {
                    if (partnerType !== "GM_Corporate" && partnerType !== "GM_Wholesale") {
                        if (key !== "ec4P00" && key !== "ec4F00" && key !== "ec4D00") {
                            header.push(filtered[key])
                        }
                    }
                    else {
                        header.push(filtered[key])
                    }
                }
            }
        }
    })





    dataListItem.filter(item => item.allocGrpCd.includes('Total')).map(filtered => {
        for (var key in filtered) {
            if (filtered.hasOwnProperty(key)) {
                if (filtered[key] !== null) {
                    if (partnerType !== "GM_Corporate" && partnerType !== "GM_Wholesale") {
                        if (key !== "ec4P00" && key !== "ec4F00" && key !== "ec4D00") {
                            total.push(filtered[key])
                        }
                    }
                    else {
                        total.push(filtered[key])
                    }
                }
            }
        }
    })



    dataListItem.filter((item) => item.allocGrpCd !== 'Total' && item.allocGrpCd !== 'Model').map((filtered) => {
        dataList.push(filtered)

    })


    dataListItem.filter(item => item.allocGrpCd.includes('Model')).map(filtered => {
        for (var key in filtered) {
            if (filtered.hasOwnProperty(key)) {
                if (filtered[key] !== null && key !== 'allocGrpCd') {
                    if (partnerType !== "GM_Corporate" && partnerType !== "GM_Wholesale") {
                        if (key !== "ec4P00" && key !== "ec4F00" && key !== "ec4D00") {
                            dataGrp.push(key)
                        }
                    }
                    else {
                        dataGrp.push(key)
                    }
                }
            }
        }
    })

    /* useEffect(() => {
        axios.get(ApiList.getEventCodes, {
            params: {
                partnerType: partnerType
            }
        })
            .then((res) => {
                setEventCodeList(res.data.eventCodeList)
            })
    }, []); */

    const modelSummary = async (e, subModel, urlLink) => {
        e.preventDefault();
        let config;
        const url = ApiList.summarybymodel;
        const data = {
            modelRequest: {
                primaryFleetAccountNumber: primaryFleetAccountNumber,
                endUserFleetAccountNumber: endUserFleetAccountNumber,
                chargeToBac: chargeToBac,
                chargeToBfc: chargeToBfc,
                shipToBac: shipToBac,
                modelYear: modelYear.toString(),
                partnerType: partnerType,
                model: subModel
            }
        }
        config = {
            headers: {
                method: 'POST',
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            }
        };

        dispatch(setOrderRequestSearchType('rightClick-Model'));
        dispatch(setOrderRequestSearchField(data));
        window.location.href = urlLink;

        /*
        const response = await axios
        axios.post(url, data, config)
            .then(response => {
                if (response.data.statusMessage === 'SUCCESS') {
                    log.info(`fos_ui_log: OrderSummaryTable():modelSummary(): Successful data fetch by model: ${subModel}`)
                    dispatch(add(response.data));
                    dispatch(setOrderRequestSearchType('leftClick'));
                    window.location.href = urlLink;
                }
                else {
                    setError(true)
                    setErrorType('error')
                    setStatusMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                    log.info(`fos_ui_log: OrderSummaryTable():modelSummary(): ${response.data.statusMessage}`)
                }
            })
            .catch((err) => {
                setError(true)
                setErrorType('error')
                setStatusMessage(intl.formatMessage({ id: err.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: err.message }))
                log.error(`fos_ui_log: OrderSummaryTable():modelSummary(): ${err.message}`)
            });*/
    }

    const allocationGroupSummary = async (e, allocation, urlLink) => {
        e.preventDefault();
        let config;
        const url = ApiList.summarybyallocationgroup;
        const data = {
            allocationGroupRequest: {
                primaryFleetAccountNumber: primaryFleetAccountNumber,
                endUserFleetAccountNumber: endUserFleetAccountNumber,
                chargeToBac: chargeToBac,
                chargeToBfc: chargeToBfc,
                shipToBac: shipToBac,
                modelYear: modelYear.toString(),
                partnerType: partnerType,
                allocationGroup: allocation
            }
        }

        config = {
            headers: {
                method: 'POST',
                'Content-Type': 'application/json',
                'guid': `${ApiList.guid}`
            }
        };

        dispatch(setOrderRequestSearchType('rightClick-Allocation'));
        dispatch(setOrderRequestSearchField(data));
        window.location.href = urlLink;

        /*
        const response = await axios
        axios.post(url, data, config)
            .then(response => {
                if (response.data.statusMessage === 'SUCCESS') {
                    log.info(`fos_ui_log: OrderSummaryTable():allocationGroupSummary(): Successful data fetch by allocation: ${allocation}`)
                    dispatch(add(response.data));
                    dispatch(setOrderRequestSearchType('leftClick'));
                    window.location.href = urlLink;
                }
                else {
                    setError(true)
                    setErrorType('error')
                    setStatusMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                    log.info(`fos_ui_log: OrderSummaryTable():allocationGroupSummary(): ${response.data.statusMessage}`)
                }

            })
            .catch((err) => {
                setError(true)
                setErrorType('error')
                setStatusMessage(intl.formatMessage({ id: err.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: err.message }))
                log.error(`fos_ui_log: OrderSummaryTable():allocationGroupSummary(): ${err.message}`)
            });*/
    }

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setError(false);
    };

    const setOrderRequestFieldByAllocation = async (allocation) => {
        const data = {
            allocationGroupRequest: {
                primaryFleetAccountNumber: primaryFleetAccountNumber,
                endUserFleetAccountNumber: endUserFleetAccountNumber,
                chargeToBac: chargeToBac,
                chargeToBfc: chargeToBfc,
                shipToBac: shipToBac,
                modelYear: modelYear.toString(),
                partnerType: partnerType,
                allocationGroup: allocation
            }
        }
        dispatch(setOrderRequestSearchField(data));
        dispatch(setOrderRequestSearchType('rightClick-Allocation'));
    }


    const setOrderRequestFieldByModel = async (subModel) => {
        const data = {
            modelRequest: {
                primaryFleetAccountNumber: primaryFleetAccountNumber,
                endUserFleetAccountNumber: endUserFleetAccountNumber,
                chargeToBac: chargeToBac,
                chargeToBfc: chargeToBfc,
                shipToBac: shipToBac,
                modelYear: modelYear.toString(),
                partnerType: partnerType,
                model: subModel
            }
        }
        dispatch(setOrderRequestSearchField(data));
        dispatch(setOrderRequestSearchType('rightClick-Model'));
        console.log(data)
    }



    return (
        <Box sx={styles.orderSummaryTable}>
            {statusMessage !== "" &&
                <ErrorSnackbarNotification errorType={errorType} open={error} handleClose={handleClose} errorMessage={statusMessage} />
            }
            <TableContainer component={Paper}>
                {dataListItem.length !== 0 && <OrderSummaryDownloadTable data={dataListItem} />}
                <Table id='tblData'>
                    <TableHead>
                        <StyledTableRow>
                            {header.map(headerItem => {
                                if (headerItem !== 'Model' && headerItem !== 'Total')
                                    return (
                                        <StyledTableCell id={headerItem+"Header"} sx={styles.orderSummaryCell}>
                                            <Stack direction="row" spacing={1}>
                                                <Grid><strong>{headerItem}</strong></Grid>
                                                {/* {eventCodeList.filter(item => item.vehEventCodes.includes(headerItem.substring(2))).map(filtered => {
                                                    return ( */}
                                                <Grid><Tooltip
                                                    title={<Typography>

                                                        {/* <FormattedMessage
                                                                    id={`eventcode.${filtered.vehEventCodes.split(' ')[0]}`}
                                                                    values={{ eventcodedesc: filtered.vehEventCodes.split(' / ')[1] }}
                                                                    defaultMessage={filtered.vehEventCodes} /> */}

                                                        <FormattedMessage
                                                            id={`eventcode.${headerItem.substring(2)}`}
                                                            defaultMessage={headerItem} />

                                                    </Typography>}
                                                    placement="top"
                                                    arrow
                                                >
                                                    <InfoIcon id={headerItem+"InfoIcon"} sx={{ fontSize: 'small' }} />
                                                </Tooltip>
                                                </Grid>
                                                {/*     )
                                                })} */}
                                            </Stack>
                                        </StyledTableCell>
                                    )
                                else if (headerItem === 'Model') {
                                    return (
                                        
                                        <StyledTableCell id="modelHeader" sx={styles.orderSummaryStickyCell}>
                                            <Stack direction="row" spacing={2}>
                                                <Grid><strong>{<FormattedMessage id='eventcode.model' defaultMessage='Model' />}</strong></Grid>
                                            </Stack>
                                        </StyledTableCell>
                                    )
                                }
                                else {
                                    return (
                                        <StyledTableCell id="totalHeader" sx={styles.orderSummaryCell}>
                                            <Stack direction="row" spacing={2}>
                                                <Grid><strong>{<FormattedMessage id='eventcode.total' defaultMessage='Total' />}</strong></Grid>
                                            </Stack>
                                        </StyledTableCell>
                                    )
                                }
                            }
                            )}
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {dataList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            return (
                                <>
                                    <StyledTableRow key={row.allocGrpCd}>
                                    <ThemeProvider theme={theme}>
                                        <StyledTableCell sx={styles.orderSummaryStickyCell}>
                                            <Grid item xs={12}>
                                                <Stack direction='row' spacing={8}>
                                                    <Grid item xs={8}>
                                                        <Link sx={styles.orderSummaryAllocationLinkStyle}
                                                            onContextMenu={() => setOrderRequestFieldByAllocation(row.allocGrpCd)}
                                                            onClick={(e) => { allocationGroupSummary(e, row.allocGrpCd, '/orderrequestlist') }}
                                                            href="/orderrequestlist"
                                                            underline="none"
                                                        >
                                                            {row.allocGrpCd}
                                                        </Link>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <IconButton
                                                            size="small"
                                                            aria-label='Dropdown'
                                                            onClick={() => setOpen(open === index ? -1 : index)}
                                                        >
                                                            {open === index ? (<KeyboardArrowUpIcon />) : (<KeyboardArrowDownIcon />)}
                                                        </IconButton>
                                                    </Grid>
                                                </Stack>
                                            </Grid>

                                        </StyledTableCell>
                                        </ThemeProvider>
                                        {dataGrp.map((data, i, arr) => {
                                            if (arr.length - 1 === i) {
                                                return (
                                                    <StyledTableCell sx={styles.orderSummaryCell}><strong>{row[data]}</strong></StyledTableCell>
                                                )
                                            }
                                            else {
                                                return (
                                                    <StyledTableCell sx={styles.orderSummaryCell}>{row[data]}</StyledTableCell>
                                                )
                                            }
                                        })}
                                    </StyledTableRow>
                                    
                                    {open === index &&
                                        <>
                                            {row.modelList.map(list => {
                                                return (
                                                    <StyledTableRow key={list.mdsngModlDesgntr}>
                                                        <StyledTableCell sx={styles.orderSummaryStickyCell}>
                                                            <Stack direction='row' spacing={5}>
                                                                <Typography sx={{ fontSize: '14px' }}>{list.allocGrpCd}&nbsp;&nbsp;&nbsp;</Typography>
                                                                <Link
                                                                    onContextMenu={() => setOrderRequestFieldByModel(list.mdsngModlDesgntr)}
                                                                    onClick={(e) => { modelSummary(e, list.mdsngModlDesgntr, '/orderrequestlist') }}
                                                                    href="/orderrequestlist"
                                                                    underline="none"
                                                                    sx={styles.orderSummaryModelLinkStyle}>{list.mdsngModlDesgntr}
                                                                </Link>
                                                            </Stack>
                                                        </StyledTableCell>
                                                        {dataGrp.map((data, i, arr) => {
                                                            if (arr.length - 1 === i) {
                                                                return (
                                                                    <StyledTableCell sx={styles.orderSummaryCell}><strong>{list[data]}</strong></StyledTableCell>
                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    <StyledTableCell sx={styles.orderSummaryCell}>{list[data]}</StyledTableCell>
                                                                )
                                                            }
                                                        })}
                                                    </StyledTableRow>
                                                )
                                            })}

                                        </>
                                    }
                                </>
                            )
                        })}
                        <StyledTableRow>
                            {total.map((total, i, arr) => {
                                if (arr.length - arr.length === i) {
                                    return (
                                        <StyledTableCellTotal sx={styles.orderRequestListStickyCell}><strong>{<FormattedMessage id='eventcode.total' defaultMessage='Total' />}</strong></StyledTableCellTotal>
                                    )
                                }
                                else {
                                    return (
                                        <StyledTableCellTotal sx={styles.orderSummaryCell}><strong>{total}</strong></StyledTableCellTotal>
                                    )
                                }
                            })}
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                labelRowsPerPage={<FormattedMessage id='labelRowsPerPage' defaultMessage='Row per page: ' />}
                hidden={dataList.length === 0}
                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={dataList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    )
}

